import type { SheetSnap } from "../../shared/types";

export interface MobileSheetState {
  filtersOpen: boolean;
  resultsSnap: SheetSnap;
}

export type MobileSheetAction =
  | { type: "open-filters" }
  | { type: "close-filters" }
  | { type: "apply-filters" }
  | { type: "show-results"; snap?: Exclude<SheetSnap, "hidden"> }
  | { type: "hide-results" }
  | { type: "map-interaction" }
  | { type: "set-results-snap"; snap: SheetSnap }
  | { type: "reset-desktop" };

export const initialMobileSheetState: MobileSheetState = {
  filtersOpen: false,
  resultsSnap: "hidden",
};

export function mobileSheetReducer(
  state: MobileSheetState,
  action: MobileSheetAction,
): MobileSheetState {
  switch (action.type) {
    case "open-filters":
      return {
        ...state,
        filtersOpen: true,
      };
    case "close-filters":
      return {
        ...state,
        filtersOpen: false,
      };
    case "apply-filters":
      return {
        ...state,
        filtersOpen: false,
      };
    case "show-results":
      return {
        ...state,
        resultsSnap: action.snap ?? "half",
      };
    case "hide-results":
    case "map-interaction":
      return {
        ...state,
        resultsSnap: "hidden",
      };
    case "set-results-snap":
      return {
        ...state,
        resultsSnap: action.snap,
      };
    case "reset-desktop":
      return initialMobileSheetState;
    default:
      return state;
  }
}
